import React, { useEffect, useState } from 'react'
import { Button, Drawer } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import longlogo from '../../images/landing/longlogo.svg'
import "../../../src/styles/header.css";

const HEADER_HEIGHT = 72

type Tab = 'home' | 'openApi' | 'zapier' | 'contact'

interface HeaderProps {
    activeTab: Tab
    setActiveTab: (view: Tab) => void
}

const Header: React.FC<HeaderProps> = ({ activeTab, setActiveTab }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
    const [drawerOpen, setDrawerOpen] = useState(false)

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const baseStyle = {
        border: '1px solid #ffffff',
        boxShadow: 'none',
        Color: '#fff',
        width: '100%',
    }

    const getStyle = (tab: Tab) => {
        const isActive = activeTab === tab

        return {
            ...baseStyle,
            color: '#ffffff',
            border: '1px solid #ffffff',
            backgroundColor: isActive ? '#f47523' : 'transparent',
            borderColor: isActive ? '#f47523' : '#fff',
            opacity: isActive ? 1 : 0.6,
        }
    }

    const handleTabClick = (tab: Tab) => {
        setActiveTab(tab)
        setDrawerOpen(false)
    }

    const MenuButtons = () => (
        <>
            <Button type="primary" style={getStyle('home')} onClick={() => handleTabClick('home')}>
                Overview
            </Button>
            <Button type="primary" style={getStyle('openApi')} onClick={() => handleTabClick('openApi')}>
                Open API
            </Button>
            <Button type="primary" style={getStyle('zapier')} onClick={() => handleTabClick('zapier')}>
                Zapier Integration
            </Button>
            <Button type="primary" style={getStyle('contact')} onClick={() => handleTabClick('contact')}>
                Contact Us
            </Button>
        </>
    )

    return (
        <header
            style={{
                backgroundColor: '#0a1526',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                minHeight: HEADER_HEIGHT,
                zIndex: 1000,
            }}
        >
            <div className="container">
                <div
                    className="landingHeader"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: '100%',
                    }}
                >
                    <div
                        className="sitelogo"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setActiveTab('home')}
                    >
                        <img src={longlogo} alt="sitelogo" />
                    </div>

                    {/* Desktop Menu */}
                    {!isMobile && (
                        <div className="d-flex gap-2 align-items-center menu-items">
                            <MenuButtons />
                        </div>
                    )}

                    {/* Mobile Hamburger */}
                    {isMobile && (
                        <>
                            <Button
                                type="text"
                                icon={<MenuOutlined style={{ fontSize: 22, color: '#fff' }} />}
                                onClick={() => setDrawerOpen(true)}
                            />

                            <Drawer
                                placement="right"
                                open={drawerOpen}
                                onClose={() => setDrawerOpen(false)}
                                bodyStyle={{ padding: 16 }}
                            >
                                <div className="d-flex flex-column gap-2">
                                    <MenuButtons />
                                </div>
                            </Drawer>
                        </>
                    )}
                </div>
            </div>
        </header>
    )
}

export default Header
